import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { IFilledQuestionnaire, IQuestionnaire } from 'src/app/modules/shared/models/operation.model';
import { IBeneficiaryObject } from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { PolicyService } from '../../../policy/policy.service';
import { claim_notification_form_keys } from './claim-notification.constants';

@Component({
  selector: 'app-claim-notification',
  templateUrl: './claim-notification.component.html',
  styleUrl: './claim-notification.component.scss'
})
export class ClaimNotificationComponent implements OnDestroy {

  @Input() form: FormGroup;
  @Input() beneficiariesList: IBeneficiaryObject[] = [];
  @Input() isReadOnly: boolean;
  @Input() questionnaireForm: FormGroup;
  @Input() questionnaires: IQuestionnaire[] = null;
  @Input() questionnairesArray: IFilledQuestionnaire[] = [];
  @Input() newLiquidationSubjects: Record<
    string,
    {
      rawFormOutcome: Record<string, any>;
      mappedOutcome: Record<string, any>;
    }
  >;

  @Output() viewSubject = new EventEmitter<any>();
  @Output() deleteSubject = new EventEmitter<any>();
  @Output() newLiquidationSubjectsChange = new EventEmitter<Record<string, { rawFormOutcome: Record<string, any>; mappedOutcome: Record<string, any> }>>();

  keys: IFormKey[] = CommonUtils.assign(claim_notification_form_keys);
  destroy$ = new Subject();

  constructor(
    private _policyService: PolicyService
  ) { }

  get isSimor(): boolean {
    return this._policyService.operationId === '_SIMOR';
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
